import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

import { StorageService } from "../../../../routes/services/storage.service";
import { Uris } from "../../../../routes/services/Uris";
import { GlobalFunction } from "../../../../routes/services/globalFuntion";
import {
  configFuzzyLogic,
  ResponseTestFuzzyLogic,
  setConfigFuzzyLogic,
  TestFuzzyLogic
} from "../interfaces/fuzzy_logic.interfaces";

@Injectable({
  providedIn: "root"
})
export class FuzzyLogicComponentService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction
  ) {}

  getConfigFuzzyLogic(id: number, TYPE: "REGION" | "CLIENTS"): Observable<configFuzzyLogic> {
    return this.http
      .get<configFuzzyLogic>(
        Uris[TYPE] + id + `/config/feeding_fuzzy_logic/${TYPE === "CLIENTS" ? "full_search/" : ""}`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: configFuzzyLogic) => {
          return resp;
        })
      );
  }
  setConfigFuzzyLogic(
    id: number,
    body: setConfigFuzzyLogic,
    TYPE: "REGION" | "CLIENTS"
  ): Observable<configFuzzyLogic> {
    return this.http
      .post<configFuzzyLogic>(
        Uris[TYPE] + id + "/config/feeding_fuzzy_logic/",
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: configFuzzyLogic) => {
          return resp;
        })
      );
  }
  deleteConfigFuzzyLogic(id: number, TYPE: "REGION" | "CLIENTS"): Observable<configFuzzyLogic> {
    return this.http
      .delete<configFuzzyLogic>(
        Uris[TYPE] + id + "/config/feeding_fuzzy_logic/",
        this.storageService.headers()
      )
      .pipe(
        map((resp: configFuzzyLogic) => {
          return resp;
        })
      );
  }

  testConfigFuzzyLogic(body: TestFuzzyLogic): Observable<ResponseTestFuzzyLogic> {
    return this.http
      .post<ResponseTestFuzzyLogic>(
        Uris.CONFIG + "feeding_fuzzy_logic/test_calc_creation/",
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: ResponseTestFuzzyLogic) => {
          return resp;
        })
      );
  }
}
